import { useAuth } from './AuthContext';

export default function LoginPage() {
  const { login } = useAuth();

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(170deg, #1e293b 0%, #0f172a 40%, #1a1a2e 100%)',
      fontFamily: "'Inter', sans-serif",
    }}>
      {/* Gold accent line at top */}
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: 3,
        background: 'linear-gradient(90deg, #b8952a, #d4b95e, #b8952a)',
      }} />

      <div style={{
        background: '#fff', borderRadius: 12, padding: '3rem 2.5rem',
        maxWidth: 380, width: '100%', textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
      }}>
        <div style={{
          fontSize: '1.6rem', fontWeight: 300, color: '#1e293b',
          letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '0.15rem',
        }}>
          Sabrina
        </div>
        <div style={{
          color: '#b8952a', fontSize: '0.65rem', fontWeight: 600,
          letterSpacing: '0.15em', textTransform: 'uppercase', marginBottom: '2.5rem',
        }}>
          Klein & Sheridan
        </div>
        <button
          onClick={login}
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
            width: '100%', padding: '0.8rem 1rem', borderRadius: 8,
            background: '#1e293b', color: '#fff', border: 'none',
            fontSize: '0.85rem', fontWeight: 500, cursor: 'pointer',
            letterSpacing: '0.03em',
          }}
        >
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}
